import { NJBadge } from "@engie-group/fluid-design-system-react";

type BadgeVariant = "neutral" | "success" | "warning" | "danger";

const STATUS_VARIANT: Record<string, BadgeVariant> = {
  ACTIVE: "success",
  PENDING: "warning",
  DISABLED: "neutral",
};

/** Colored status pill for agents/skills (ACTIVE / PENDING / DISABLED). */
export function StatusBadge({ status }: { status: string | null | undefined }) {
  const value = status ?? "ACTIVE";
  return (
    <NJBadge variant={STATUS_VARIANT[value] ?? "neutral"}>{value}</NJBadge>
  );
}
